import React from 'react';
import EvaluationCard from './EvaluationCard';

const Evaluations = (props: any) => {
  const { data, type } = props;
  return <div className='left-section-rt-container'>
    {data.map((e: any) => <EvaluationCard data={e} type={type}/>)}
  </div>;
};
export default Evaluations;